import { render, staticRenderFns } from "./SearchRecommend.vue?vue&type=template&id=6f740e65&scoped=true&"
import script from "./SearchRecommend.vue?vue&type=script&lang=js&"
export * from "./SearchRecommend.vue?vue&type=script&lang=js&"
import style0 from "./SearchRecommend.vue?vue&type=style&index=0&id=6f740e65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f740e65",
  null
  
)

export default component.exports